const SET_ERROR = (state, errors) => {
  state.errors = errors;
};

const SET_USER_EXAM_LIST = (state, data) => {
  state.exams = [];

  data.data.forEach(exam => {
    
    if (exam.exam != null) {
      state.exams.push(exam)
    }
  });
};

const SET_USER_EXAM_CATEGORY = (state, data) => {
  state.categories = data;
};

const SET_USER = (state, user) => {
  state.user = user;
};

const SET_IS_LOADING_EXAM = (state, status) => {
  state.isLoadingExam = status;
}

const SET_IS_LOADING_TRANSACTION = (state, status) => {
  state.isLoadingExam = status;
}

const SET_USER_TRANSACTION_LIST = (state, data) => {
  state.transactions = data.data;
};

const SET_USER_DEPOSIT_LIST = (state, data) => {
  state.deposits = data.data;
};

const SET_CITY_LIST = (state, data) => {
  state.cityList = data;
};

const SET_WARD_LIST = (state, data) => {
  state.wardList = data;
};

const SET_COD_LOADING = (state, data) => {
  state.isLoadingCOD = data;
};

const SET_COD_MESSAGE = (state, data) => {
  state.codStatus = data.status;
  state.codMessage = data.message;
};

export default {
  SET_ERROR,
  SET_USER_EXAM_LIST,
  SET_USER_EXAM_CATEGORY,
  SET_USER,
  SET_IS_LOADING_EXAM,
  SET_IS_LOADING_TRANSACTION,
  SET_USER_TRANSACTION_LIST,
  SET_USER_DEPOSIT_LIST,
  SET_CITY_LIST,
  SET_WARD_LIST,
  SET_COD_LOADING,
  SET_COD_MESSAGE
};